﻿export const arrayWithNewItem = <T>(array: T[], itemToAdd: T): T[] => ([...array, itemToAdd]);
